import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetPeriodsInputDto, PeriodCreateDto, PeriodDto, PeriodExcelDownloadDto, PeriodUpdateDto } from '../dtos/period/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class PeriodService {
  private restService = inject(RestService);
  apiName = 'Controlling';
  

  create = (input: PeriodCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PeriodDto>({
      method: 'POST',
      url: '/api/controlling/periods',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/controlling/periods/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/controlling/periods',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PeriodDto>({
      method: 'GET',
      url: `/api/controlling/periods/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/controlling/periods/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetPeriodsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<PeriodDto>>({
      method: 'GET',
      url: '/api/controlling/periods',
      params: { periodTypeId: input.periodTypeId, periodTypeName: input.periodTypeName, name: input.name, month: input.month, monthFrom: input.monthFrom, monthTo: input.monthTo, year: input.year, yearFrom: input.yearFrom, yearTo: input.yearTo, stockStartDate: input.stockStartDate, stockStartDateFrom: input.stockStartDateFrom, stockStartDateTo: input.stockStartDateTo, stockEndDate: input.stockEndDate, stockEndDateFrom: input.stockEndDateFrom, stockEndDateTo: input.stockEndDateTo, liquidationStartDate: input.liquidationStartDate, liquidationStartDateFrom: input.liquidationStartDateFrom, liquidationStartDateTo: input.liquidationStartDateTo, liquidationEndDate: input.liquidationEndDate, liquidationEndDateFrom: input.liquidationEndDateFrom, liquidationEndDateTo: input.liquidationEndDateTo, isStockActive: input.isStockActive, isLiquidationActive: input.isLiquidationActive, isActivityReportIntegrationActive: input.isActivityReportIntegrationActive, isMm4InterfaceActive: input.isMm4InterfaceActive, isWoodValorizationClosed: input.isWoodValorizationClosed, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: PeriodExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/controlling/periods/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, periodTypeId: input.periodTypeId, periodTypeName: input.periodTypeName, name: input.name, month: input.month, monthFrom: input.monthFrom, monthTo: input.monthTo, year: input.year, yearFrom: input.yearFrom, yearTo: input.yearTo, stockStartDate: input.stockStartDate, stockStartDateFrom: input.stockStartDateFrom, stockStartDateTo: input.stockStartDateTo, stockEndDate: input.stockEndDate, stockEndDateFrom: input.stockEndDateFrom, stockEndDateTo: input.stockEndDateTo, liquidationStartDate: input.liquidationStartDate, liquidationStartDateFrom: input.liquidationStartDateFrom, liquidationStartDateTo: input.liquidationStartDateTo, liquidationEndDate: input.liquidationEndDate, liquidationEndDateFrom: input.liquidationEndDateFrom, liquidationEndDateTo: input.liquidationEndDateTo, isStockActive: input.isStockActive, isLiquidationActive: input.isLiquidationActive, isActivityReportIntegrationActive: input.isActivityReportIntegrationActive, isMm4InterfaceActive: input.isMm4InterfaceActive, isWoodValorizationClosed: input.isWoodValorizationClosed, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PeriodDto[]>({
      method: 'GET',
      url: '/api/controlling/periods/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: PeriodUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PeriodDto>({
      method: 'PUT',
      url: `/api/controlling/periods/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}